// src/vocabulary/B1/unit3/questions.js

const questions = [
  // 🟢 Easy – meaning
  {
    id: 1,
    type: "choice",
    question: "What does 'tall' mean?",
    options: ["قصير", "طويل", "سمين"],
    correctAnswer: "طويل"
  },

  {
    id: 2,
    type: "choice",
    question: "Which phrase means 'شعر قصير'?",
    options: ["long hair", "short hair", "thin hair"],
    correctAnswer: "short hair"
  },

  // 🟡 Medium – usage
  {
    id: 3,
    type: "choice",
    question: "Choose the correct sentence:",
    options: [
      "She is tall.",
      "She tall is.",
      "She is tall hair."
    ],
    correctAnswer: "She is tall."
  },

  {
    id: 4,
    type: "choice",
    question: "Which sentence describes hair?",
    options: [
      "He is tall.",
      "She has long hair.",
      "They are thin."
    ],
    correctAnswer: "She has long hair."
  },

  // 🔵 Harder – combining ideas
  {
    id: 5,
    type: "choice",
    question: "Which sentence gives more detail?",
    options: [
      "He is tall.",
      "He is tall with short hair.",
      "He tall short hair."
    ],
    correctAnswer: "He is tall with short hair."
  },

  {
    id: 6,
    type: "choice",
    question: "When do people usually describe appearance?",
    options: [
      "When talking about someone",
      "When ordering food",
      "When asking for directions"
    ],
    correctAnswer: "When talking about someone"
  }
];

export default questions;


